import { StarbaseEntity, Serializable } from 'starbase-launcher';
import { RankCategory } from './rankCategory';
import { IColumnModel, ColumnModel } from 'table-editor';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';

export class Rank extends StarbaseEntity implements Serializable<Rank> {
    public rankCategory: RankCategory;
    public rankName: string;
    public rankDisplay: string;
    public rankCategoryName: string;
    public rankCategoryId: number;

  constructor() {
    super();
  }

    public static RankColumnData(rankCategories: RankCategory[], editable: boolean = false): IColumnModel[] {
        // rankCategories = onlyUniqueByKey(rankCategories, 'uid');
        rankCategories.forEach(r => {
            r.rankCategoryName = r.rankCategory;
        });
        return [
            new ColumnModel('UID', 'uid', 'uid', false, 'number', false, true, 10, false),
            new ColumnModel('Rank Category', 'rankCategoryName', 'rankCategory', editable, 'dropdown', true, true, 100, true, rankCategories, 'rankCategoryName'),
            new ColumnModel('Rank Name', 'rankName', 'rankName', editable, 'string', false, true, 100, true),
            new ColumnModel('Rank Category ID', 'rankCategoryId', 'rankCategoryId', false, 'number', false, true, 100, true),
            new ColumnModel('Created Date/Time', 'createdDateTime', 'createdDateTime', false, 'date', false, true, 50, false),
            new ColumnModel('Created By', 'createdByUser', 'createdByUser', false, 'string', false, true, 50, false)
        ];
    }
    public static CreateRankColumnData(rankCategories: RankCategory[]): IColumnModel[] {
        rankCategories.forEach(r => {
            r.rankCategoryName = r.rankCategory;
        });
        return [
            new ColumnModel('Rank Category', 'rankCategoryName', 'rankCategory', true, 'dropdown', false, true, 100, true, rankCategories, 'rankCategoryName'),
            new ColumnModel('Rank Name', 'rankName', 'rankName', true, 'string', false, true, 100, true)
        ];
    }

    public static setupRankCollection(collection: Rank[]): void {
        of(collection).pipe(
            map((r: Rank[]) =>
                r.map((rank: Rank) => {
                    rank.rankDisplay = rank.rankCategory.rankCategory + ' - ' + rank.rankName;
                    rank.rankCategoryName = rank.rankCategory.rankCategory;
                    rank.rankCategory = new RankCategory().deserialize(rank.rankCategory);
                    rank = new Rank().deserialize(rank);
                    return new Rank().deserialize(rank);
                })
            )
        ).subscribe();
    }

    deserialize(input) {
        const r = Object.assign(new Rank(), input);
        r.rankDisplay = r.concatRank();
        return r;
    }

    public concatRank(): string {
        return ((this.rankCategory) ? this.rankCategory.rankCategory + ' - ' : '') + this.rankName;
    }
}
